import React from "react";

import { handleAdd, handleThemeChange } from "../actions";
import { ModalService, ModalTypes } from "../../../../service/modal-service";
import InviteModal from "./invite";
import { withStyles } from "@material-ui/core/styles";
import MaterialButton from "@material-ui/core/Button";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Theme } from "../../../../theme/theme-provider";

import {
  faEllipsisH,
  faPlus,
  faUserPlus,
  faPen,
} from "@fortawesome/free-solid-svg-icons";

const StyledMenuItem = withStyles((theme) => ({
  root: {
    "&:focus": {
      backgroundColor: `red`,
      "& .MuiListItemIcon-root, & .MuiListItemText-primary": {
        color: theme.palette.common.white,
      },
    },
  },
}))(MenuItem);

export default function CustomizedMenus({ roomInfo, refresh }) {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const { id } = roomInfo || {};

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const options = [
    {
      text: "Add Songs",
      icon: faPlus,
      onClick: () => {
        handleAdd({ roomInfo, refresh });
        handleClose();
      },
    },
    {
      text: "Edit Theme",
      icon: faPen,
      onClick: () => {
        handleThemeChange({ refresh, roomInfo });
        handleClose();
      },
    },
    {
      text: `Invite`,
      icon: faUserPlus,
      onClick: () => {
        ModalService.showModal(ModalTypes.CUSTOM, {
          width: "30%",
          height: "180px",
          content: <InviteModal roomId={id} />,
        });
        handleClose();
      },
    },
  ];

  return (
    <div>
      <MaterialButton
        style={{
          borderRadius: 50,
          color: Theme.color.BLUE_5,
          borderColor: Theme.color.BLUE_5,
        }}
        aria-controls="customized-menu"
        aria-haspopup="true"
        variant="outlined"
        onClick={handleClick}
      >
        <FontAwesomeIcon icon={faEllipsisH} />
      </MaterialButton>
      <Menu
        elevation={0}
        getContentAnchorEl={null}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
        id="customized-menu"
        anchorEl={anchorEl}
        style={{ color: "#fff" }}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        {options.map(({ text, icon, onClick }) => (
          <StyledMenuItem onClick={onClick}>
            <ListItemIcon>
              <FontAwesomeIcon icon={icon} />
            </ListItemIcon>
            <ListItemText primary={text} />
          </StyledMenuItem>
        ))}
      </Menu>
    </div>
  );
}
